import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDropdown = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.25 6.96118L10.2944 12.9167C10.2558 12.9554 10.2099 12.9861 10.1594 13.0071C10.1089 13.028 10.0547 13.0388 10 13.0388C9.94531 13.0388 9.89115 13.028 9.84062 13.0071C9.7901 12.9861 9.7442 12.9554 9.70556 12.9167L3.75 6.96118",
		stroke: "#8C94AA",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgDropdown);
export default ForwardRef;
